interface PriceExampleRow {
  config: string;
  price: string;
  package: string;
}

interface PriceExamplesTableProps {
  title?: string;
  rows: PriceExampleRow[];
  footnote?: string;
}

/**
 * PriceExamplesTable
 *
 * Static three-column "Konfiguration · Preis · Paket" table used by
 * `priceExamples` sections. Helps prospects map their own scope to the
 * pricing tiers above without using the interactive calculator.
 */
export default function PriceExamplesTable({
  title,
  rows,
  footnote,
}: PriceExamplesTableProps) {
  if (!Array.isArray(rows) || rows.length === 0) {
    throw new Error("PriceExamplesTable: `rows` array is empty or invalid.");
  }

  return (
    <div className="price-examples">
      {title ? <h4 className="price-examples-title">{title}</h4> : null}
      <div className="price-examples-table-wrap">
        <table className="price-examples-table">
          <thead>
            <tr>
              <th scope="col">Konfiguration</th>
              <th scope="col">Preis</th>
              <th scope="col">Paket</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={`${row.config}-${idx}`}>
                <td>{row.config}</td>
                <td className="price-examples-price">{row.price}</td>
                <td className="price-examples-package">{row.package}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {footnote ? <p className="price-examples-footnote">{footnote}</p> : null}
    </div>
  );
}
